/**
 * Get nested object value
 *
 * @param {Object} data object from which data will be obtained
 * @param {string} path of the information we're goint to get
 */
function gnov(data: any, path: string): any {
  const steps = path.split('.');
  return steps.reduce(
    (obj, key) => (obj && obj[key] !== 'undefined' ? obj[key] : undefined),
    data
  );
}

export default gnov;
